// 调整颜色的饱和度和亮度
export function lightenColor(color, bool = true, percentage = 100) {
  // 将颜色转换为 HSL
  const rgbToHsl = (r, g, b) => {
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }

      h /= 6;
    }

    return [h, s, l];
  };

  // 将 HSL 转回 RGB
  const hslToRgb = (h, s, l) => {
    let r, g, b;

    if (s === 0) {
      r = g = b = l;
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };

      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;

      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  };

  // 解析颜色
  let r, g, b;
  if (color.startsWith("#")) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else if (color.startsWith("rgb")) {
    const match = color.match(/\d+/g);
    if (!match) throw new Error("Invalid RGB format");
    [r, g, b] = match.map(Number);
  } else {
    throw new Error("Invalid color format");
  }

  // 转换为 HSL，调整饱和度和亮度，再转回 RGB
  let [h, s, l] = rgbToHsl(r, g, b);

  // console.log("hsl", h, s, l);

  // 降低饱和度，增加亮度，但保持颜色特性
  s = Math.max(0.5, s > 0.85 ? 1 : s - percentage / 200); // 降低饱和度
  l = Math.min(s > 0.85 ? 0.9 : 0.95, l + percentage / 200); // 适度增加亮度，但不超过0.9

  [r, g, b] = hslToRgb(h, s, l);
  return bool ? `rgba(${r}, ${g}, ${b}, ${s > 0.85 ? 0.5 : 0.3})` : `rgba(${r}, ${g}, ${b})`;
}

const types = ["default", "primary", "success", "info", "warning", "danger"];

const getColorTagStyle = ({ elTagType }) => {
  if (types.includes(elTagType.trim())) {
    return {};
  }

  return { color: elTagType, borderColor: lightenColor(elTagType, false) };
};

const getColorTagProps = ({ elTagType = "" }) => {
  if (types.includes(elTagType.trim())) {
    if (elTagType.trim() === "default") {
      return {
        type: "primary"
      };
    }
    return {
      type: elTagType
    };
  }

  return { color: lightenColor(elTagType) };
};

export { getColorTagProps, getColorTagStyle };
